import { Button, TextField } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

export default function SendCredit({ api }) {
    const history = useHistory();
    const [username, setUsername] = useState('')
    const [amount, setAmount] = useState(0)
    const [pass, setPass] = useState('')
    const [password, setPassword] = useState('')
    const [message, setMessage] = useState('')
    const [value, setValue] = React.useState(false)
    useEffect(() => {
        setValue(Math.random() < 0.5)
    }, [])
    return (
        <div style={{ padding: 10 }}>
            <form onSubmit={e => {
                e.preventDefault();
                api.axios.post("/reward/" + pass, {
                    reason: message,
                    pass: password,
                    credit: amount, username
                })
                    .then(d => {
                        api.showSnack('Amount Sent Successfully.', 'success')
                    })
                    .catch(e => api.showSnack(e.error || 'Something went wrong', 'error'))

            }}>
                <TextField required fullWidth value={username} onChange={e => setUsername(e.target.value)} label="Enter Username to send" />
                <br />
                <br />
                <TextField required fullWidth value={amount} onChange={e => setAmount(e.target.value)} label="Enter Amount to Send" />
                <br />
                <br />
                <TextField required fullWidth value={value ? pass : password} onChange={e => value ? setPass(e.target.value) : setPassword(e.target.value)} label={value ? "Enter PassCode (1)" : "Enter PassCode (2)"} />
                <br />
                <br />
                <TextField required fullWidth value={value ? password : pass} onChange={e => value ? setPassword(e.target.value) : setPass(e.target.value)} label={value ? "Enter PassCode (2)" : "Enter PassCode (1)"} />
                <br />
                <br />
                <TextField required fullWidth value={message} onChange={e => setMessage(e.target.value)} multiline={true} rows={3} label="Enter your message" />
                <br /><br />
                <Button type="submit" variant="outlined">Send Credit</Button>
            </form>
        </div>
    )
}
